angular.module('ui.omStat', [])
    .directive('omStat', function ($timeout, customTemplateResolver) {

        return {
            restrict: 'EA',
            scope: {
                items: '=items'
            }, // use a new isolated scope
            template: customTemplateResolver.get('omStat.html', 'app/ui/omStat/omStat.html'),
            controller: 'OmStatController'
        };

    })

    .directive('honeyButton', function ($timeout, customTemplateResolver) {

        return {
            restrict: 'EA',
            bindToController: true,
            scope: {
                color: '@',
                targetUri: '@',
                iconName: '@',
                title: '@',
                label: '@'
            }, // use a new isolated scope
            template: customTemplateResolver.get('honeyButton.html', 'app/ui/omStat/honeyButton.html'),
            controller: 'HoneyButtonController'
        };
    })
    .controller('HoneyButtonController', function HoneyButtonController($scope, $window) {

        //set the title to be at least '&nbsp;' when it's empty
        //the special space symbol (alt+255) entered in the string here, will
        //be converted by angular into 'nbsp;'
        $scope.titleInternal = !$scope.title ? ' ' : $scope.title;

        $scope.openTargetUri = function () {
            $window.location = $scope.targetUri;
        };
    })

    .directive('bookmarkButton', function ($timeout, customTemplateResolver) {

        return {
            restrict: 'EA',
            bindToController: true,
            scope: {
                color: '@',
                targetUri: '@',
                iconName: '@',
                title: '@',
                label: '@'
            }, // use a new isolated scope
            template: customTemplateResolver.get('bookmarkButton.html', 'app/ui/omStat/bookmarkButton.html'),
            controller: 'BookmarkButtonController'
        };

    })
    .controller('BookmarkButtonController', function BookmarkButtonController($scope, $window) {

        $scope.openTargetUri = function () {
            $window.location = $scope.targetUri;
        };

    })

    .controller('OmStatController', function OmStatController($scope) {

        //The controller code executes before the compilation of the template (rendering)
        //var items = $scope.items;


    })

;